import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Table } from "reactstrap";

const EventDetailModal = ({ isOpen, toggle, event }) => {
  if (!event) return null;

  const formatDate = (date) => {
    if (!date) return "N/A";
    return new Date(date).toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const formatTimeSlots = (timeSlots) => {
    if (!timeSlots || timeSlots.length === 0) return [];
    
    // Sort time slots
    const sorted = [...timeSlots].sort((a, b) => {
      const [hourA] = a.split(':').map(Number);
      const [hourB] = b.split(':').map(Number);
      return hourA - hourB;
    });

    // Group consecutive hours
    const groups = [];
    let start = sorted[0];
    let prev = sorted[0];

    for (let i = 1; i < sorted.length; i++) {
      const current = sorted[i];
      const [prevHour] = prev.split(':').map(Number);
      const [currHour] = current.split(':').map(Number);

      if (currHour - prevHour > 1) {
        groups.push(start === prev ? start : `${start} - ${prev}`);
        start = current;
      }
      prev = current;
    }
    groups.push(start === prev ? start : `${start} - ${prev}`);
    
    return groups;
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalHeader toggle={toggle}>
        <i className="ri-calendar-event-line me-2"></i>
        {event.title}
      </ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <h6 className="text-muted mb-3">Campaign Details</h6>
          <Table bordered size="sm">
            <tbody>
              <tr>
                <td width="30%"><strong>Campaign ID:</strong></td>
                <td>{event.campaignId || 'N/A'}</td>
              </tr>
              <tr>
                <td><strong>Campaign Name:</strong></td>
                <td>{event.title}</td>
              </tr>
              <tr>
                <td><strong>Date:</strong></td>
                <td>{formatDate(event.date)}</td>
              </tr>
              <tr>
                <td><strong>Total Time Slots:</strong></td>
                <td>{event.timeSlots?.length || 0} hours</td>
              </tr>
            </tbody>
          </Table>
        </div>

        {event.timeSlots && event.timeSlots.length > 0 && (
          <div>
            <h6 className="text-muted mb-3">Scheduled Time Slots</h6>
            <div className="border rounded p-3" style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {formatTimeSlots(event.timeSlots).map((slot, index) => (
                <div key={index} className="mb-2 p-2 bg-light rounded">
                  <i className="ri-time-line me-2"></i>
                  <strong>{slot}</strong>
                </div>
              ))}
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={toggle}>
          Close
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default EventDetailModal;
